import React from "react";
import { Link, useNavigate } from "react-router-dom";
import backSvg from "../../images/back.svg";

const PageTitle = ({ onClick, to }) => {
  let path = window.location.pathname.split("/");
  const navigate = useNavigate();
  return (
    <div className="row page-titles">
      <div
        onClick={() => onClick ? onClick() : to ? navigate(to) : navigate(-1)}
        class="d-flex gap-1 align-items-center text-primary font-w500"
      >
        <img src={backSvg} />
        <span>Back</span>
      </div>
    </div>
  );
};

export default PageTitle;
